import {useEffect, useContext} from 'react';
import {useToggle} from 'react-use';
import { useTrail, useSpring, useTransition, animated } from 'react-spring';
import SETTINGS from '../settings';
import {useMeasure} from 'react-use';

import RecipeContext from '../utils/recipe-context';
import {RECIPES} from '../recipes/recipe-list';

import SiteSelector from '../components/site-selector';

import classNames from 'classnames';
import log from 'loglevel';

import {FW, FA} from '../utils/font-awesome';

const GridX = props => (
  <div className={classNames("grid-x", props.className)}>
    {props.children}
  </div>
);

const MainBody = props => (
  <div className={classNames("auto cell main-body", props.className)}>
    {props.children}
  </div>
);

const SideBar = props => {
  const [mini, changeMini] = useToggle(localStorage.getItem('awi_minimenu') || window.innerWidth < 720);

  const spring = useSpring({
    config:SETTINGS.ANIMATION.DEFAULT,
    // ref:springRef,
    width: mini ? '52px' : '320px'
  });

  useEffect(() => {
    localStorage.setItem('awi_minimenu', mini ? '1' : '');
  }, [mini]);

  const trail = useTrail(RECIPES.length+2, {
    config:SETTINGS.ANIMATION.DEFAULT,
    // ref:trailRef,
    width: mini ? '0%' : '100%'
  });

  const [selectorMeasure, { height:selectorHeight }] = useMeasure();
  const selectorTransition = useTransition(!mini, null, {
    config: SETTINGS.ANIMATION.DEFAULT,
    from: {height:0},
    enter:{height:selectorHeight},
    update:{height:selectorHeight},
    leave:{height:0}
  });

  return (
    <animated.div style={spring} className={classNames("cell side-menu sticky-menu hide-for-print", props.className)}>
      {selectorTransition.map(({item, key, props}) =>
        item && <animated.div key={key} style={props} className="side-menu-child">
          <div ref={selectorMeasure}>
            <SiteSelector/>
          </div>
        </animated.div>

      )}
      <ul>
        <SideMenu mini={mini} trail={trail} />
        <hr key="sm-hr-last" />
        <li key="sm-hide-sidebar">
          <div className="menu-item" onClick={changeMini}>
            <div className="icon"><FW icon={mini ? 'toggle-off' : 'toggle-on'} /></div>
            <animated.div style={trail[RECIPES.length+1]} className="text">Hide Sidebar</animated.div>
          </div>
        </li>
      </ul>
    </animated.div>
  );
}

const SideMenu = props => {
  const recipeContext = useContext(RecipeContext);

  return (
      RECIPES.map((item, id) =>
        item.type == 'hr' ? <hr key={"hr"+id} /> :
          <li key={"sm"+id+item.name}>
            <a href={"#" + item.slug}
              className={classNames(id == recipeContext.currentRecipeID && 'active', 'menu-item')}>
              <div className="icon"><FW icon={item.icon}/></div>
              <animated.div style={props.trail[id]} className="text">{item.name}</animated.div>
            </a>
          </li>
      )
  );
}

const Footer = props =>
  <section className="padded">
    <footer>
      <div><small><FA icon="copyright"/> {(new Date()).getFullYear()} Designed and Managed by Architects Workshop India. All Rights Reserved.</small></div>
    </footer>
  </section>


export const Layout = {GridX, MainBody, SideBar, SideMenu, Footer};
